import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';
import {
  addSupportServices,
  getSupportServicesById,
  updateSupportServices,
} from 'app/api/supportservices';
import {
  supportServiceValidationRules,
  validate,
} from 'app/constants/validation-constants';
import Message from 'app/utils/Message';
import Toast from 'app/utils/Toast';
import { LocalSessionKey } from 'app/constants/app-constants';
import { LocalStorage } from 'app/utils/storage';

const useUserProfilePage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setErrors] = useState({});
  const [values, setValues] = useState({
    phone: '',
    name: '',
  });

  const supportId = location?.state?.id ? location?.state?.id : '';
  const userMallListResponse = useMemo(() => {
    return JSON.parse(LocalStorage.get(LocalSessionKey.USER_INFO));
  }, []);

  useEffect(() => {
    setValues({ ...userMallListResponse });
    setPageLoading(false);
  }, []);

  async function loadStoreData(id) {
    if (!id) {
      return;
    }

    setPageLoading(true);
    let response = await getSupportServicesById(id);
    setPageLoading(false);
    if (response?.responseCode === 200) {
      let responsedata = response?.data;

      setValues({
        phone: responsedata?.phone,
        name: responsedata?.name,
      });
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  async function callAddOrUpdateAPI() {
    setPageLoading(true);
    let response = {};

    if (supportId) {
      response = await updateSupportServices(supportId, { ...values });
    } else {
      response = await addSupportServices({ ...values });
    }
    setPageLoading(false);

    if (response?.responseCode === 200) {
      Toast.success(
        supportId
          ? Message.Support_Service.UPDATED_SUCCESS
          : Message.Support_Service.CREATED_SUCCESS
      );
      navigate(-1);
    } else {
      Toast.error(
        response?.response?.message
          ? response?.response?.message
          : Message.Error.COMMON_MESSAGE
      );
    }
  }

  function handleUserProfilePage(e) {
    e.preventDefault();
    const validationErrors = validate(values, supportServiceValidationRules);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      callAddOrUpdateAPI();
    }
  }

  function handleChange(e) {
    if (e && e.target) {
      const { name, value } = e.target;
      setValues({
        ...values,
        [name]: name === 'contact_number' ? parseInt(value) : value,
      });

      if (error[name]) {
        setErrors({
          ...error,
          [name]: '',
        });
      }
    }
  }
  function setChange(name, val) {
    setValues((prevState) => ({
      ...prevState,
      [name]: val,
    }));
    setErrors({
      ...error,
      [name]: '',
    });
  }

  return {
    setChange,
    handleChange,
    values,
    error,
    handleUserProfilePage,
    pageLoading,
    supportId,
    navigate,
  };
};

export default useUserProfilePage;
